import { render } from "./fixedAssetProducts.vue?vue&type=template&id=65a1e2de&scoped=true"
import script from "./fixedAssetProducts.vue?vue&type=script&lang=js"
export * from "./fixedAssetProducts.vue?vue&type=script&lang=js"

import "./fixedAssetProducts.vue?vue&type=style&index=0&id=65a1e2de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a1e2de"]])

export default __exports__